import React from 'react';
import { Link } from 'react-router-dom';


export const mahalleler = [
  { 
    id: 1, 
    name: 'Barbaros Mahallesi', 
    image: '/assets/images/mahalleler/barbaros/1.jpg', 
    urlTag: 'barbaros',
    totalImages: 5
  },
  { 
    id: 2, 
    name: 'Cumhuriyet Mahallesi', 
    image: '/assets/images/mahalleler/cumhuriyet/1.jpg', 
    urlTag: 'cumhuriyet',
    totalImages: 2
  },
  { 
    id: 3, 
    name: 'Denizciler Mahallesi', 
    image: '/assets/images/mahalleler/denizciler/1.jpg', 
    urlTag: 'denizciler',
    totalImages: 2
  },
  { 
    id: 4, 
    name: 'Gültepe Mahallesi', 
    image: '/assets/images/mahalleler/gultepe/1.jpg', 
    urlTag: 'gultepe',
    totalImages: 14
  },
  { 
    id: 5, 
    name: 'İsmet İnönü Mahallesi', 
    image: '/assets/images/mahalleler/ismet-inonu/1.jpg', 
    urlTag: 'ismet-inonu',
    totalImages: 1
  },
  { 
    id: 6, 
    name: 'Akçay Mahallesi', 
    image: '/assets/images/mahalleler/akçay/1.jpg', 
    urlTag: 'akçay',
    totalImages: 1
  },
  { 
    id: 7, 
    name: 'Azganlık Mahallesi', 
    image: '/assets/images/mahalleler/azganlık/1.jpg', 
    urlTag: 'azganlık',
    totalImages: 1
  },
  { 
    id: 8, 
    name: 'Aşkarbeyli Mahallesi', 
    image: '/assets/images/mahalleler/aşkarbeyli/1.jpg', 
    urlTag: 'aşkarbeyli',
    totalImages: 1
  },
  { 
    id: 9, 
    name: 'Bekbele Mahallesi', 
    image: '/assets/images/mahalleler/bekbele/1.jpg', 
    urlTag: 'bekbele',
    totalImages: 1
  },
  { 
    id: 10, 
    name: 'Büyükdere Mahallesi', 
    image: '/assets/images/mahalleler/büyükdere/1.jpg', 
    urlTag: 'büyükdere',
    totalImages: 1
  },
  { 
    id: 11, 
    name: 'Cebike Mahallesi', 
    image: '/assets/images/mahalleler/cebike/1.jpg', 
    urlTag: 'cebike',
    totalImages: 1
  },
  { 
    id: 12, 
    name: 'Dumlupınar Mahallesi', 
    image: '/assets/images/mahalleler/dumlupınar/1.jpg', 
    urlTag: 'dumlupınar',
    totalImages: 1
  },
  { 
    id: 13, 
    name: 'Esentepe Mahallesi', 
    image: '/assets/images/mahalleler/esentepe/1.jpg', 
    urlTag: 'esentepe',
    totalImages: 1
  },
  { 
    id: 14, 
    name: 'Fatih Sultan Mehmet Mahallesi', 
    image: '/assets/images/mahalleler/fatih-sultan-mehmet/1.jpg', 
    urlTag: 'fatih-sultan-mehmet',
    totalImages: 1
  },
  { 
    id: 15, 
    name: 'Gürsel Mahallesi', 
    image: '/assets/images/mahalleler/gürsel/1.jpg', 
    urlTag: 'gürsel',
    totalImages: 1
  },
  { 
    id: 16, 
    name: 'Kocatepe Mahallesi', 
    image: '/assets/images/mahalleler/kocatepe/1.jpg', 
    urlTag: 'kocatepe',
    totalImages: 1
  },
  { 
    id: 17, 
    name: 'Numune Mahallesi', 
    image: '/assets/images/mahalleler/numune/1.jpg', 
    urlTag: 'numune',
    totalImages: 1
  },
  { 
    id: 18, 
    name: 'Sarıseki Mahallesi', 
    image: '/assets/images/mahalleler/sarıseki/1.jpg', 
    urlTag: 'sarıseki',
    totalImages: 1
  },
  { 
    id: 19, 
    name: 'Süleymaniye Mahallesi', 
    image: '/assets/images/mahalleler/süleymaniye/1.jpg', 
    urlTag: 'süleymaniye',
    totalImages: 1
  },
  { 
    id: 20, 
    name: 'Çay Mahallesi', 
    image: '/assets/images/mahalleler/çay/1.jpg', 
    urlTag: 'çay',
    totalImages: 1
  }
];

const Mahalleler = () => {
  return (
    <div className="mahalleler-page">
      <div className="container lg-py-5">
      
          <div className="col-md-12">
            <h1 className="page-title mb-4">Mahallem Gelişiyor</h1>
            <div className="row g-4">
              {mahalleler.map((mahalle) => (
                <div key={mahalle.id} className="col-md-4">
                  <Link to={`/mahalleler/${mahalle.urlTag}`} className="mahalle-card">
                    <div className="mahalle-card-image">
                      <img src={mahalle.image} alt={mahalle.name} />
                    </div>
                    <div className="mahalle-card-content">
                      <h3>{mahalle.name}</h3>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
       
      </div>
    </div>
  );
};

export default Mahalleler;
